export const loginFields = {
  UserName: {
    fieldKey: "UserName",
    element: "input",
    type: "email",
    title: "UserName",
    placeholder: "login-user-email-placeholder",
    label: "login-user-email-label",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  },
  Password: {
    fieldKey: "Password",
    element: "input",
    type: "password",
    title: "Password",
    placeholder: "login-password-placeholder",
    label: "login-password-label",
    hidePassStrength: true,
  },
  Remember: {
    fieldKey: "Remember",
    element: "checkbox",
    title: "Remember",
    label: "login-remember-label",
    containerClassName: "half-width-field",
  },
  ForgotPassword: {
    fieldKey: "ForgotPassword",
    element: "text",
    title: "ForgotPassword",
    label: "forgot-password-text",
    linkData: { old: false, page: "password-recover" },
    containerClassName: "half-width-field restore-password",
  },
};
